// ScoutingNarrativeCard — main column above-the-fold scouting prose.
//
// Trust-attribution model: the narrative is agent-written today, so we
// surface an "Agent Verified" pill in the header. Phase A may later flip
// some narratives to auto-generated; that'd swap the pill (or hand it
// off to PlayerHero's SyncBadge) — out of scope here.
//
// Empty state renders a placeholder rather than hiding the card, so the
// main-column rhythm stays consistent across players (some have a
// narrative, some don't).

interface Props {
  narrative: string | null
}

export default function ScoutingNarrativeCard({ narrative }: Props) {
  return (
    <section className="bg-hoop-surface border border-hoop-border rounded-2xl p-5">
      <h2 className="text-[12px] font-bold uppercase tracking-wider text-hoop-accent mb-3">
        Scouting Narrative
      </h2>

      {narrative ? (
        <p
          className="whitespace-pre-line text-hoop-text"
          style={{ fontSize: '13.5px', lineHeight: 1.7 }}
        >
          {narrative}
        </p>
      ) : (
        <p className="text-sm text-hoop-text-3">
          No scouting narrative yet.
        </p>
      )}
    </section>
  )
}
